export function McpSection() {
  return (
    <section className="mcp-home-section shell" id="mcp">
      <div className="mcp-copy fade-up">
        <span className="kicker">LANDED MCP</span>
        <h2>
          Your ideas don&rsquo;t have to start <em>in Landed.</em>
        </h2>
        <p>
          Connect Landed to Claude and create, update, manage, and publish without leaving the
          conversation. Your AI assistant now has somewhere to build.
        </p>
        <ul>
          <li>
            <span>&#10003;</span>Create websites from a conversation
          </li>
          <li>
            <span>&#10003;</span>Update content and design with natural language
          </li>
          <li>
            <span>&#10003;</span>Manage projects and publish instantly
          </li>
        </ul>
        <a className="btn-primary-landing" href="/mcp">
          Connect Landed to Claude &#8599;
        </a>
      </div>
      <div className="claude-window">
        <div className="claude-top">
          <span className="claude-mark">AI</span>
          <b>Claude</b>
          <span>&bull;&bull;&bull;</span>
        </div>
        <div className="chat-bubble user">
          Create a waitlist landing page for a new productivity app called Daylight.
        </div>
        <div className="tool-call">
          <span className="landed-mini">&#9670;</span>
          <div>
            <small>Using Landed</small>
            <b>Creating your site&hellip;</b>
          </div>
          <i>&#10003;</i>
        </div>
        <div className="chat-bubble assistant">
          Your Daylight launch page is ready&mdash;with a connected waitlist form and custom
          confirmation page.
        </div>
        <div className="published">
          <div className="published-inner">
            <small>DAYLIGHT</small>
            <b>
              Make room
              <br />
              for what matters.
            </b>
            <span>Join the early access list</span>
          </div>
          <p>
            <i>&#9679;</i> Published&nbsp;&nbsp; daylight.landed.site
          </p>
        </div>
      </div>
    </section>
  );
}
